module.exports = __webpack_public_path__ + "img/config_exam.f756d262.png";